import { financeFetcher } from './fetcher';

export const getEntityByOrganizationId = organizationId => {
    return financeFetcher.get(`/finance_entities/?owner=weez:organization:${organizationId}`).then(({ response }) => {
        return response.length > 0 ? response[0] : null;
    });
};

export const updateEntity = (entityId, data) => {
    return financeFetcher.put(`/finance_entities/${entityId}`, {
        data
    });
};

export const getDocumentHeads = financeEntityId => {
    return financeFetcher.get(`/finance_entities/${financeEntityId}/document_heads`).then(({ response }) => response);
};

export const getBankAccounts = financeEntityId => {
    return financeFetcher.get(`/finance_entities/${financeEntityId}/bank_accounts`).then(({ response }) => response);
};

export const getPayoutProfiles = financeEntityId => {
    return financeFetcher.get(`/finance_entities/${financeEntityId}/payout_profiles`).then(({ response }) => response);
};
